import { Box, Stack } from '@mui/material';
import {
  DateCalendar,
  DayCalendarSkeleton,
  LocalizationProvider,
  MonthCalendar,
} from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DayCalendar } from '@mui/x-date-pickers/internals';
import dayjs, { Dayjs } from 'dayjs';
import { useState } from 'react';

import { checkDayIsIncluded } from '@/ui/pages/app/project/venue/dates/components/utils/check-day-is-included';
import { VenueDateCalendar } from '@/ui/pages/app/project/venue/dates/view-calendar/VenueDateCalendar';
import { VenueMonthCard } from '@/ui/pages/app/project/venue/dates/view-calendar/VenueMonthCard';

export function DevCalendarsVenue() {
  return (
    <>
      <h2> VenueDateCalendarCard compo</h2>
      <VenueMonthCardDemo />
      <h2>final VenueDateCalendar compo</h2>
      <Stack spacing={2} sx={{ alignItems: 'center' }}>
        <Box sx={{ border: 'solid 1px white' }}>
          <p>title</p>
          <Box sx={{ backgroundColor: 'red', border: 'solid 1px white' }}>
            <CalendardFinal />
          </Box>
          <p>scores</p>
        </Box>
      </Stack>

      <h2>playground</h2>
      <CalendarsPlayground />
    </>
  );
}

function VenueMonthCardDemo() {
  const month = dayjs('2025-03');
  const month2 = dayjs('2025-04');
  const [selectedDays, setSelectedDays] = useState<Dayjs[]>([
    dayjs('2025-03-04'),
    dayjs('2025-03-07'),
    dayjs('2025-03-23'),
  ]);
  const onClickDate = (date: Dayjs | null) => {
    if (!date) return;
    if (checkDayIsIncluded(selectedDays, date)) {
      setSelectedDays(
        selectedDays.filter((day) => day.toISOString() !== date.toISOString()),
      );
    } else {
      setSelectedDays([...selectedDays, date]);
    }
  };
  return (
    <Stack sx={{ alignItems: 'center', flexDirection: 'row', gap: 2 }}>
      <VenueMonthCard
        month={month}
        selectedDays={selectedDays}
        onClickDate={onClickDate}
        scores={{
          co2: '-',
          env: '-',
          ess: '-',
          totalMen: '-',
          totalWomen: '-',
          totalOther: '-',
        }}
      />
      <VenueMonthCard
        month={month2}
        selectedDays={selectedDays}
        onClickDate={onClickDate}
        scores={{
          co2: 'A',
          env: 'B',
          ess: 'C',
          totalMen: '-',
          totalWomen: '-',
          totalOther: '-',
        }}
      />
    </Stack>
  );
}

function CalendardFinal() {
  const month = dayjs('2025-03');
  const [selectedDays, setSelectedDays] = useState<Dayjs[]>([
    dayjs('2025-03-04'),
    dayjs('2025-03-07'),
    dayjs('2025-03-23'),
  ]);

  const onClickDate = (date: Dayjs | null) => {
    if (!date) return;
    if (checkDayIsIncluded(selectedDays, date)) {
      setSelectedDays(
        selectedDays.filter((day) => day.toISOString() !== date.toISOString()),
      );
    } else {
      setSelectedDays([...selectedDays, date]);
    }
  };
  return (
    <VenueDateCalendar
      month={month}
      selectedDays={selectedDays}
      onClickDate={onClickDate}
    />
  );
}
function CalendarsPlayground() {
  const locale = 'fr';

  return (
    <Stack sx={{ flexDirection: 'row', gap: 2, flexWrap: 'wrap' }}>
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={locale}>
        <DateCalendar />
        <DateCalendar defaultValue={dayjs('2022-04-17')} />
        <DateCalendar
          defaultValue={dayjs('2022-04-17')}
          views={['year', 'month', 'day']}
        />
        <div>
          <p>only month (no view no year)</p>
          <DateCalendar views={['day']} referenceDate={dayjs('2022-04')} />
          <DateCalendar views={['day']} referenceDate={dayjs('2022-05')} />
        </div>
        <div>
          <MonthCalendar />
          <DayCalendar
            currentMonth={dayjs('2025-03')}
            selectedDays={[dayjs('2025-03-04'), dayjs('2025-03-07')]}
            onSelectedDaysChange={() => {}}
            focusedDay={dayjs('2025-03-10')}
            isMonthSwitchingAnimating={false}
            onFocusedDayChange={() => {}}
            onMonthSwitchingAnimationEnd={() => {}}
            reduceAnimations={false}
            slideDirection="left"
            maxDate={dayjs('2099-12-31')}
            minDate={dayjs('1900-01-01')}
            disableFuture={false}
            disablePast={false}
            disableHighlightToday={undefined}
            timezone="default"
            readOnly={false}
            hasFocus={true}
            disabled={undefined}
            shouldDisableDate={undefined}
            shouldDisableMonth={undefined}
            shouldDisableYear={undefined}
          />
          <DayCalendarSkeleton />
        </div>
        <div>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <h1 className="userH1 text-3xl text-center pt-4">Availability</h1>
            <DateCalendar
              className=" w-[283px]"
              readOnly={true}
              views={['day']}
              renderLoading={() => (
                <DayCalendarSkeleton className=" w-[283px]" />
              )}
            />
          </LocalizationProvider>
        </div>
      </LocalizationProvider>
    </Stack>
  );
}
